//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    link: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      active: false
    }
  },
  computed: {

  },
  methods: {
    getLinkProps (link) {
      if (link.action) {
        return {
          href: link.link
          // href: '#'
        }
      } else {
        return {
          to: link.link
        }
      }
    },
    toggleInnerMenu () {
      this.active = !this.active
    },
    actions(type, e) {
      this.$store.commit('sidebars/profileAsideClose')
      switch(type) {
        case 'deleteToken':
          this.$cookies.remove('token')
          break
        case 'openFeedback':
          e.preventDefault()
          this.$store.commit('sidebars/asideClose')
          this.$store.commit('sidebars/feedbackAsideOpen')
          break
        default:
          return null
          break
      }
    }
  },
}
